import React, { useState, useEffect, useRef } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import { AuthContext } from "../utility/AuthContext";

function Signup() {
  const [user, setUser] = useState("");
  const [role, setRole] = useState("Doctor");
  const [name, setName] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const formRef = useRef();
  const { login } = useContext(AuthContext);

  const handleSignUp = async (e) => {
    setIsSubmitting(true);
    e.preventDefault(); // Prevent page reload

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      return;
    }

    const formData = new FormData(formRef.current);

    try {
      const response = await fetch(API_BASE_URL + "/api/signup", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        login(user, role, name);
        formRef.current.reset();
        window.accessToken = data.access_token;
        navigate("/dashboard");
      } else {
        alert(data.error || "Invalid login.");
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Server error : " + error.message);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="d-flex flex-column justify-content-center align-items-center vh-100"
        style={{
          background:
            "linear-gradient(to bottom right, #6c63ff 50%, #162447 50%)",
        }}
      >
        <div className="text-white mb-4 fw-bold">
          <h2>Welcome</h2>
        </div>
        <div
          className="p-5 rounded-4 shadow bg-white text-center"
          style={{ width: "350px" }}
        >
          <h3 className="mb-4 fw-semibold text-secondary">Sign Up</h3>
          <hr />
          <form ref={formRef}>
            <div className="mb-3 text-start">
              <input
                type="text"
                value={user}
                onChange={(e) => setUser(e.target.value)}
                required
                placeholder="Username"
                name="user"
                className="form-control bg-light"
              />
            </div>

            <div className="mb-3 text-start position-relative">
              <input
                type={showPassword ? "text" : "password"}
                required
                placeholder="Password"
                name="password"
                className="form-control bg-light"
              />
              <i
                // className="fa-solid fa-eye toggle-password"
                className={`bi ${
                  showPassword ? "bi-eye-slash" : "bi-eye"
                } position-absolute`}
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  right: "15px",
                  top: "10px",
                  cursor: "pointer",
                  zIndex: 2,
                }}
              ></i>
            </div>
            <div className="mb-3 text-start position-relative">
              <input
                type="password"
                required
                placeholder="Confirm Password"
                name="confirm_password"
                className="form-control bg-light"
              />
            </div>
            <div className="mb-3 text-start position-relative">
              <input
                type="password"
                required
                placeholder="Passkey"
                name="passkey"
                className="form-control bg-light"
              />
            </div>
            <div className="mb-3 text-start position-relative">
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                required
                className="form-select bg-light"
                name="role"
              >
                <option value="Doctor">Doctor</option>
                <option value="Operator">Operator</option>
                <option value="Admin">Admin</option>
              </select>
            </div>
            <div className="mb-3 text-start position-relative">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required={role === "Doctor"}
                placeholder="Name"
                name="name"
                className="form-control bg-light"
              />
            </div>
          </form>
          <div className="d-flex justify-content-between mt-4">
            <button
              className="btn btn-primary px-4"
              onClick={handleSignUp}
              disabled={isSubmitting}
            >
              Sign Up
            </button>
            <button
              className="btn btn-info text-white px-4"
              onClick={() => navigate("/")}
              disabled={isSubmitting}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signup;
